<template>
   <el-row :gutter="20"  style="padding: 30px;min-height: 800px;">
    <el-button   icon="el-icon-arrow-left" class="btnback" @click="btnBack">公告首页</el-button>
        <h1 class="title">{{notice.Title}}</h1>
        <div class="el-line-h"></div>
        <div class="noticetime">{{notice.InsertTime}}</div>
        <div class="notictcontent" v-html="notice.NoticeContent"></div>

    </el-row>

</template>

<script>

import bus from "../common/bus.js";
import netutil from "../common/netutil.js";

export default {

    data() {
        return {
            defaultIndex:'1',
            page: '1',
            notice:{}

        };
    },
    components: {
       
    },
    computed: {

    },
    created() {
       this.getNotice();
    },
    mounted() {
        
    },
    deactivated() {

       
    },
    methods: {
        btnBack()
        {
            this.$router.push('/about?index=2');
        },
        getNotice() {
            var self = this;
            let id = this.$route.query.id;
            var param = {
                id:id
            };
            netutil.get("public/getnotice", param,
                function (data) {
                    self.notice = data.data0[0];
                },
                function (msg) {

                });
        },
    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
    padding: 40px;
}

.title {
    font-size: 26px;
    width: 100%;
    text-align: center;
    line-height: 50px;
    font-weight: 400;
    color: rgb(86, 86, 86);
}

.subtitle {
    font-size: 20px;
    line-height: 40px;
    font-weight: 400;

}

.subcontent {
    font-size: 18px;
    line-height: 30px;
    color: rgb(124, 124, 124);
    padding-left: 20px;
    margin-bottom: 30px;
}

.el-icon-star-on
{
    color: #ffa01b;
}

.notictcontent{
    line-height: 26px;
    margin-top: 20px;
}

.noticetime
{
    text-align: right;
    line-height:40px;
}

.btnback
{
    border-color: rgb(255, 255, 255);
    background-color: rgb(255, 255, 255);
    font-size: 16px;
}
.btnback:hover
{
    color: black;
}
</style>
